var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.includes(_vm.label))?_c('span',{staticClass:"flex items-center font-medium tracking-wide text-red-500 text-xs mt-1",class:_vm.classes},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }